<template>
    <div  class="mt-12 container ">
        <div class="" style="width: 100%;">
            <div class="card" style="background: #fff; width: 100%;">
                <div style="background: #D6ECF5; height: 47px; padding: 10px; font-size: 15px; font-weight: 500;">Agent Information</div>
                <div class="py-2 px-5 card" style="background: #fff; width: 100%;">
                    <div class="my-8 mx-5">
                        <b-avatar class="mr-8" src="https://placekitten.com/300/300" size="7rem"></b-avatar>
                    </div>
                    <!-- Person information Fields -->
                    <div class="row">
                        <div class="py-2 px-5 col-lg-6">
                            <div class="continer">
                                <div class="mb-3 row">
                                    <label for="inputPassword" class="surname_text col-lg-4">Surname</label>
                                    <div class="col-lg-8">
                                        <input type="text" v-model="surname" placeholder="Surname" class="px-6 surename" id="surename">
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label for="inputPassword" class="surname_text col-lg-4">Othername</label>
                                    <div class="col-lg-8">
                                        <input type="text" v-model="othername" placeholder="Othername" class="px-6 surename" id="othername">
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label for="inputPassword" class="surname_text col-lg-4">Date of Birth</label>
                                    <div class="col-lg-8">
                                        <b-form-datepicker v-model="dob" class="px-6 py-2 surename" id="datepicker-dateformat2" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="en"></b-form-datepicker>
                                        <!-- <input type="number" placeholder="30-11-1990"  id="surename"> -->
                                    </div>
                                </div>
                                <!--  -->
                                <div class="mb-3 row">
                                    <label for="inputPassword" class="surname_text col-lg-4">Nationality</label>
                                    <div class="col-lg-8">
                                        <b-form-select v-model="nationality_state" class="px-6 nationality_field" :options="nation" id="nationality"></b-form-select>
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label for="inputPassword" class="surname_text col-lg-4">L.G.A</label>
                                    <div class="col-lg-8">
                                        <b-form-select v-model="lga_state" class="px-6 nationality_field" :options="lga" id="lga"></b-form-select>
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label for="inputPassword" class="residential_text col-lg-2">Residential Address</label>
                                    <div class="col-lg-8">
                                        <input type="text" v-model="residential" placeholder="Type Address" class="px-6 residential" id="residential">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Second Colum -->
                        <div class="col-lg-6">
                            <div class="continer">
                                <div class="mb-3 row">
                                    <label for="inputPassword" class="surname_text col-lg-4">First Name</label>
                                    <div class="col-lg-8">
                                        <input type="text" v-model="firstname" placeholder="First Name" class="px-6 surename" id="firstname">
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label for="inputPassword" class="surname_text col-lg-4">Email Addess</label>
                                    <div class="col-lg-8">
                                        <input type="email" v-model="email" placeholder="Email Address" class="px-6 residential" id="emailaddress">
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label for="inputPassword" class="surname_text col-lg-4">Gender</label>
                                    <div class="col-lg-8">
                                        <b-form-select v-model="gender_state" placeholder="Female" class="px-6 nationality_field" :options="gender" id="gender"></b-form-select>
                                    </div>
                                </div>
                                <!--  -->
                                <div class="mb-3 row">
                                    <label for="inputPassword" class="surname_text col-lg-4">State of Origin</label>
                                    <div class="col-lg-8">
                                        <b-form-select v-model="state_state" class="px-6 nationality_field" :options="stateOfOrigin" id="stateoforigin"></b-form-select>
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label for="inputPassword" class="residential_text col-lg-4">Town</label>
                                    <div class="col-lg-8">
                                        <input type="text" v-model="town" placeholder="Type Town" class="px-6 residential" id="town">
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label for="inputPassword" class="surname_text col-lg-4">Next of Kin</label>
                                    <div class="col-lg-8">
                                        <input type="text" v-model="nextofkin" placeholder="Enter Next of Kin" class="px-6 residential" id="nextKin">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>
    
    <script>
    import axios from 'axios';
    import Swal from "sweetalert2";
    // import FormConfirm from "./FormConfirm.vue"
    
    export default {
        data() {
            return {
                inputs: [{
                    name: '',
                    grade: ''
                }],
    
                examName: '',
                examNo: '',
    
                nationality_state: null,
                lga_state: null,
                state_state: null,
                gender_state: null,
                surname: '',
                firstname: '',
                othername: '',
                email: '',
                dob: '',
                residential: '',
                workexperience: '',
                town: '',
                nextofkin: '',
                faculty: '',
                department: '',
                entryMode: '',
                courseOfStudy: '',
                modalShow: false,
    
                nation: [{
                        value: null,
                        text: 'Nationality'
                    },
                    {
                        value: 'a',
                        text: 'NIGERIA'
                    },
                    {
                        value: 'b',
                        text: 'AMERICA'
                    },
                    {
                        value: 'c',
                        text: 'GHANA'
                    },
                    {
                        value: 'd',
                        text: 'SOUTH AFRICA',
                        // disabled: true
                    }
                ],
    
                lga: [{
                        value: null,
                        text: 'LGA'
                    },
                    {
                        value: 'a',
                        text: 'AGUATA'
                    },
                    {
                        value: 'b',
                        text: 'OYI'
                    },
                    {
                        value: 'c',
                        text: 'AWKA NORTH'
                    },
                    {
                        value: 'd',
                        text: 'AWKA SOUTH',
                        // disabled: true
                    }
                ],
                stateOfOrigin: [{
                        value: null,
                        text: 'Select State'
                    },
                    {
                        value: 'a',
                        text: 'ABIA'
                    },
                    {
                        value: 'b',
                        text: 'ANAMBRA'
                    },
                    {
                        value: 'c',
                        text: 'ENUGU'
                    },
                    {
                        value: 'd',
                        text: 'DELTA',
                        // disabled: true
                    }
                ],
                gender: [{
                        value: null,
                        text: 'Gender'
                    },
                    {
                        value: 'a',
                        text: 'Male'
                    },
                    {
                        value: 'b',
                        text: 'Female'
                    },
                ]
            }
        },
    
        methods: {
            handleOk() {
                if (this.inputs.length < 9) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Incomplete Record',
                        text: 'You Need a Maximum of 9 subjects to continue',
                        width: 400,
                    })
                } else {
                    this.modalShow = false;
                }
            },
    
            add() {
                if (this.inputs.length < 9) {
                    this.inputs.push({
                        name: '',
                        grade: ''
                    });
                } else {
                    Swal.fire({
                        icon: 'error',
                        // title: 'Maximum Field',
                        text: 'Maximum Field Reached',
                        width: 400,
                    })
                }
            },
            remove(index) {
                this.inputs.splice(index, 1);
            },
    
            clear() {
                this.surname = '';
                this.nationality_state = 0;
                this.lga_state = 0;
                this.state_state = 0;
                this.gender_state = 0;
                this.surname = '';
                this.firstname = '';
                this.othername = '';
                this.email = '';
                this.dob = '';
                this.residential = '';
                this.workexperience = '';
                this.town = '';
                this.nextofkin = '';
                this.faculty = '';
                this.department = '';
                this.entryMode = '';
                this.courseOfStudy = '';
                this.examName = '';
                this.examNo = '';
            },
    
            done() {
                if (this.surname == '' || this.nationality_state < 1 || this.lga_state < 1 || this.state_state < 1 || this.gender_state < 1 || this.surname == '' || this.firstname == '' || this.othername == '' || this.email == '' || this.dob == '' ||
                    this.residential == '' || this.workexperience == '' || this.town == '' || this.nextofkin == '' || this.faculty == '' || this.department == '' || this.entryMode == '' || this.courseOfStudy == '') {
                    Swal.fire({
                        icon: 'error',
                        title: 'Incomplete',
                        text: 'Please Complete the form',
                        width: 400,
                    })
                } else {
                    this.$refs['modal-x'].show()
                }
            },
    
            async submit() {
                await axios.post('createaccount', {
                    nationality_state: this.nationality_state,
                    lga_state: this.lga_state,
                    state_state: this.state_state,
                    gender_state: this.gender_state,
                    surname: this.surname,
                    firstname: this.firstname,
                    othername: this.othername,
                    email: this.email,
                    dob: this.dob,
                    residential: this.residential,
                    workexperience: this.workexperience,
                    town: this.town,
                    nextofkin: this.nextofkin,
                    faculty: this.faculty,
                    department: this.department,
                    entryMode: this.entryMode,
                    courseOfStudy: this.courseOfStudy,
                });
                setTimeout(() => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Submitted',
                        text: 'Proceed to Biometric Capture',
                        width: 400,
                    })
                }, 2000);
    
                setTimeout(() => {
                    this.$refs['modal-x'].hide()
                }, 4000);
    
                this.clear();
                this.inputs.length = 0;
            },
        },
    }
    </script>
    
    <style scoped>
    @import url('https://fonts.googleapis.com/css?family=Proxima+Nova');
    
    .surname_text {
        font-family: Proxima Nova;
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 16px;
        display: flex;
        align-items: center;
        text-align: center;
    
        color: #4F4F4F;
    }
    
    .add_result {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 15px;
        width: 180px;
        height: 55px;
        color: #006794;
        background: #D6ECF5;
        /* border-radius: 3px; */
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
    }
    
    .done_button {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 15px;
        width: 335px;
        height: 45px;
        background: #006794;
        border-radius: 3px;
        color: #FFFFFF;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
    }
    
    .result_new_button {
        /* padding: 15px; */
        width: 150px;
        height: 45px;
        background: #D6ECF5;
        border-radius: 3px;
        color: #006794;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
    }
    
    .result_add_button {
        /* padding: 15px; */
        width: 100px;
        height: 45px;
        background: #006794;
        border-radius: 3px;
        color: #FFFFFF;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
    }
    
    .submit_button {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 15px;
        width: 205px;
        height: 45px;
        background: #006794;
        border-radius: 3px;
        color: #FFFFFF;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
        margin-bottom: 20px;
    }
    
    .back_button {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 15px;
        width: 205px;
        height: 45px;
        background: #D6ECF5;
        border-radius: 3px;
        color: #006794;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
        margin-bottom: 20px;
    }
    
    .residential_text {
        font-family: Proxima Nova;
        font-style: normal;
        font-weight: 500;
        font-size: 17px;
        line-height: 16px;
        display: flex;
        align-items: center;
        text-align: left;
    
        color: #4F4F4F;
    }
    
    .surename {
        width: 100%;
        height: 50px;
        background-color: rgb(216, 216, 216);
        border-radius: 5px;
    }
    
    .residential {
        width: 100%;
        height: 50px;
        background: #FFFFFF;
        border: 1px solid #E8E9EC;
        box-sizing: border-box;
        border-radius: 3px;
    }
    
    .nationality_field {
        width: 100%;
        height: 50px;
        /* background: #FFFFFF; */
        border: 1px solid #E8E9EC;
        box-sizing: border-box;
        border-radius: 3px;
    }
    </style>
    